import { render } from "./imgfinal_ingles.vue?vue&type=template&id=67268e12&scoped=true"
import script from "./imgfinal_ingles.vue?vue&type=script&lang=js"
export * from "./imgfinal_ingles.vue?vue&type=script&lang=js"

import "./imgfinal_ingles.vue?vue&type=style&index=0&id=67268e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67268e12"]])

export default __exports__